

import portfolio1 from "../../../src/assets/images/portfolio1.png";
import portfolio2 from "../../../src/assets/images/portfolio2.jpg";
import portfolio3 from "../../../src/assets/images/portfolio3.jpg";
import portfolio4 from "../../../src/assets/images/portfolio4.jpg";
import portfolio5 from "../../../src/assets/images/portfolio5.jpg";


import moviedb1 from "../../../src/assets/images/moviedb/1.png";
import moviedb2 from "../../../src/assets/images/moviedb/2.png";
import moviedb3 from "../../../src/assets/images/moviedb/3.png";
import moviedb4 from "../../../src/assets/images/moviedb/4.png";
import moviedb5 from "../../../src/assets/images/moviedb/5.png";
import moviedb6 from "../../../src/assets/images/moviedb/6.png";
import moviedb7 from "../../../src/assets/images/moviedb/7.png";
import moviedb8 from "../../../src/assets/images/moviedb/8.png";
import moviedb9 from "../../../src/assets/images/moviedb/9.png";
import moviedb10 from "../../../src/assets/images/moviedb/10.png";
import moviedb11 from "../../../src/assets/images/moviedb/11.png";
import moviedb12 from "../../../src/assets/images/moviedb/12.png";




const PortfolioApi = {

    categories: [
        {
            id: "ios-development",
            name: "iOS Development",
            projects: [
                {
                    "id":  1,
                    "title": "Movie Database (TMDB) App with SwiftUI",
                    "banner": portfolio1,
                    "description": "The Movie Database (TMDB) is a popular, user editable database for movies and TV shows.",
                    "longDescription": "",
                    "role": "",
                    "appArchitecture": "MVVM Pattern",
                    "techStack": ["iOS", "Swift", "SwiftUI", "TMDB API"],
                    "url": "https://ecommerceplatform.example.com",
                    "sourceCode": "https://github.com/sinbadbd/MovieZoo",
                    "developmentProcess": "Used Agile Scrum methodology with continuous integration and deployment strategies.",
                    "challenges": [
                        {
                            "problem": "Integration of multiple payment gateways",
                            "solution": "Developed a modular gateway integration system allowing easy addition of new payment methods."
                        }
                    ],
 
                    "screenshots": [moviedb1, moviedb2, moviedb3, moviedb4, moviedb5, moviedb6, moviedb7, moviedb8, moviedb9, moviedb10, moviedb11,moviedb12],
                    "videoDemo": "https://www.youtube.com/embed/Qp-aXKIuJ1U?si=RIXdQYCFdoveVTAy?autoplay=1",
                    "documentationLink": "https://developer.themoviedb.org/reference/intro/getting-started",
                    "features": [
                        "OnBoard",
                        "Upcoming, Trending, Now Playing Movies",
                        "Real-time search and filtering",
                        "User authentication and profile management",
                        "Bookmark and watchlist functionality",
                        "Multi color themes",
                      ],
       
                    "awards": ["2024 Best Tech Innovation"],
               
                    "collaborators": [
                        {
                            "name": "John Smith",
                            "role": "Lead Designer"
                        }
                    ],
                    "completionDate": "2023-12-01",
                    "caseStudies": "https://example.com/casestudies/advancedecommerce",
                    "futureEnhancements": "Plans to implement blockchain for secure transactions and a loyalty reward system.",
 
                },
                {
                    "id":  2,
                    "title": "Movie Database (TMDB) with UIKit",
                    "banner": portfolio1,
                    "description": "The Movie Database (TMDB) is a popular, user editable database for movies and TV shows.",
                    "longDescription": "The Movie Database (TMDB) is a community built movie and TV database. ",
                    "role": "",
                    "appArchitecture": "MVVM-Coordinator Pattern",
                    "techStack": ["iOS", "Swift", "UIKit", "TMDB API", "Alamofire", "SDWebImage", "RxCocoa", "RxSwift", "SwiftyJSON", "SkeletonView","XCGLogger","PromiseKit"],
                    "url": "https://ecommerceplatform.example.com",
                    "sourceCode": "https://github.com/sinbadbd/MovieZoo",
                    "developmentProcess": "",
                    "challenges": [
                        {
                            "problem": " ",
                            "solution": " "
                        }
                    ],
    
                    "screenshots": [moviedb1, moviedb2, moviedb3, moviedb4, moviedb5, moviedb6, moviedb7, moviedb8, moviedb9, moviedb10, moviedb11,moviedb12],
                    "videoDemo": "https://www.youtube.com/watch?v=Cwm9YAT4tNI",
                    "documentationLink": "https://developer.themoviedb.org/reference/intro/getting-started",
                    "features": [
                        "OnBoard",
                        "Upcoming, Trending, Now Playing Movies",
                        "Real-time search and filtering",
                        "User authentication and profile management",
                        "Bookmark and watchlist functionality",
                        "Multi color themes",
                      ],
      
                    "awards": ["2024 Best Tech Innovation"],
         
                    "collaborators": [
                        {
                            "name": "John Smith",
                            "role": "Lead Designer"
                        }
                    ],
                    "completionDate": "2023-12-01",
                    "caseStudies": "https://example.com/casestudies/advancedecommerce",
                    "futureEnhancements": "Plans to implement blockchain for secure transactions and a loyalty reward system.",
     
                }
                ,{
                    "id": 3,
                    "title": "WeatherSwiftUI",
                    "banner": portfolio1,
                    "description": "",
                    "longDescription": "",
                    "role": "",
                    "appArchitecture": "MVVM",
                    "techStack": ["iOS", "Swift", "SwiftUI", "TMDB API"],
                    "url": "",
                    "sourceCode": "",
                    "developmentProcess": "Used Agile Scrum methodology with continuous integration and deployment strategies.",
                    "challenges": [
                        {
                            "problem": "Integration of multiple payment gateways",
                            "solution": "Developed a modular gateway integration system allowing easy addition of new payment methods."
                        }
                    ],
               
                    "screenshots": [moviedb1, moviedb2, moviedb3, moviedb4, moviedb5, moviedb6, moviedb7, moviedb8, moviedb9, moviedb10, moviedb11,moviedb12],
                    "videoDemo": "https://www.youtube.com/watch?v=Qp-aXKIuJ1U",
                    "documentationLink": "https://developer.themoviedb.org/reference/intro/getting-started",
                    "features": [
                        "OnBoard",
                        "Upcoming, Trending, Now Playing Movies",
                        "Real-time search and filtering",
                        "User authentication and profile management",
                        "Bookmark and watchlist functionality",
                        "Multi color themes",
                      ],
                
                    "awards": ["2024 Best Tech Innovation"],
               
                    "collaborators": [
                        {
                            "name": "John Smith",
                            "role": "Lead Designer"
                        }
                    ],
                    "completionDate": "2023-12-01",
                    "caseStudies": "https://example.com/casestudies/advancedecommerce",
                    "futureEnhancements": "Plans to implement blockchain for secure transactions and a loyalty reward system.",
               
                },
                ,{
                    "id": 4,
                    "title": "Instagram clone with UIKit",
                    "banner": portfolio1,
                    "description": "",
                    "longDescription": "",
                    "role": "",
                    "appArchitecture": "MVVM",
                    "techStack": ["iOS", "Swift", "SwiftUI", "TMDB API"],
                    "url": "",
                    "sourceCode": "",
                    "developmentProcess": "Used Agile Scrum methodology with continuous integration and deployment strategies.",
                    "challenges": [
                        {
                            "problem": "Integration of multiple payment gateways",
                            "solution": "Developed a modular gateway integration system allowing easy addition of new payment methods."
                        }
                    ],
               
                    "screenshots": [moviedb1, moviedb2, moviedb3, moviedb4, moviedb5, moviedb6, moviedb7, moviedb8, moviedb9, moviedb10, moviedb11,moviedb12],
                    "videoDemo": "https://www.youtube.com/watch?v=Qp-aXKIuJ1U",
                    "documentationLink": "https://developer.themoviedb.org/reference/intro/getting-started",
                    "features": [
                        "OnBoard",
                        "Upcoming, Trending, Now Playing Movies",
                        "Real-time search and filtering",
                        "User authentication and profile management",
                        "Bookmark and watchlist functionality",
                        "Multi color themes",
                      ],
                
                    "awards": ["2024 Best Tech Innovation"],
               
                    "collaborators": [
                        {
                            "name": "John Smith",
                            "role": "Lead Designer"
                        }
                    ],
                    "completionDate": "2023-12-01",
                    "caseStudies": "https://example.com/casestudies/advancedecommerce",
                    "futureEnhancements": "Plans to implement blockchain for secure transactions and a loyalty reward system.",
               
                },
                ,{
                    "id": 5,
                    "title": "News App with SwiftUI (Multiplafrom)",
                    "banner": portfolio1,
                    "description": "",
                    "longDescription": "",
                    "role": "",
                    "appArchitecture": "MVVM",
                    "techStack": ["iOS", "Swift", "SwiftUI", "TMDB API"],
                    "url": "",
                    "sourceCode": "",
                    "developmentProcess": "Used Agile Scrum methodology with continuous integration and deployment strategies.",
                    "challenges": [
                        {
                            "problem": "Integration of multiple payment gateways",
                            "solution": "Developed a modular gateway integration system allowing easy addition of new payment methods."
                        }
                    ],
               
                    "screenshots": [moviedb1, moviedb2, moviedb3, moviedb4, moviedb5, moviedb6, moviedb7, moviedb8, moviedb9, moviedb10, moviedb11,moviedb12],
                    "videoDemo": "https://www.youtube.com/watch?v=Qp-aXKIuJ1U",
                    "documentationLink": "https://developer.themoviedb.org/reference/intro/getting-started",
                    "features": [
                        "OnBoard",
                        "Upcoming, Trending, Now Playing Movies",
                        "Real-time search and filtering",
                        "User authentication and profile management",
                        "Bookmark and watchlist functionality",
                        "Multi color themes",
                      ],
                
                    "awards": ["2024 Best Tech Innovation"],
               
                    "collaborators": [
                        {
                            "name": "John Smith",
                            "role": "Lead Designer"
                        }
                    ],
                    "completionDate": "2023-12-01",
                    "caseStudies": "https://example.com/casestudies/advancedecommerce",
                    "futureEnhancements": "Plans to implement blockchain for secure transactions and a loyalty reward system.",
               
                },
                ,{
                    "id": 6,
                    "title": "VPN App UI with SwiftUI",
                    "banner": portfolio1,
                    "description": "",
                    "longDescription": "",
                    "role": "",
                    "appArchitecture": "MVVM",
                    "techStack": ["iOS", "Swift", "SwiftUI", "TMDB API"],
                    "url": "",
                    "sourceCode": "",
                    "developmentProcess": " ",
                    "challenges": [
                        {
                            "problem": "Integration of multiple payment gateways",
                            "solution": "Developed a modular gateway integration system allowing easy addition of new payment methods."
                        }
                    ],
               
                    "screenshots": [moviedb1, moviedb2, moviedb3, moviedb4, moviedb5, moviedb6, moviedb7, moviedb8, moviedb9, moviedb10, moviedb11,moviedb12],
                    "videoDemo": "https://www.youtube.com/watch?v=Qp-aXKIuJ1U",
                    "documentationLink": "https://developer.themoviedb.org/reference/intro/getting-started",
                    "features": [
                        "OnBoard",
                        "Upcoming, Trending, Now Playing Movies",
                        "Real-time search and filtering",
                        "User authentication and profile management",
                        "Bookmark and watchlist functionality",
                        "Multi color themes",
                      ],
                
                    "awards": [],
               
                    "collaborators": [
                        {
                            "name": "John Smith",
                            "role": "Lead Designer"
                        }
                    ],
                    "completionDate": "2023-12-01",
                    "caseStudies": "https://example.com/casestudies/advancedecommerce",
                    "futureEnhancements": "Plans to implement blockchain for secure transactions and a loyalty reward system.",
               
                }
                
                
                // Add more projects if needed
            ]
        },
        {
            id: "web-development",
            name: "Web Development",
            projects: [
                
            ]
        }
    ]

}

export default PortfolioApi